import React from 'react';
import { render } from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { Provider } from 'react-redux';

import { newStore } from './stores/store';
import Layout from './layout-page/Layout';
import Landing from './landing/Landing';
import Register from './register-page/Register';
import Reviews from './blocks/review/ReviewLanding';
// import About from './about-page/About';
import UserProfile from './user-profile-page/UserProfile';
import Authorization from './authorization-page/Authorization';
import Speakers from './speakers-page/Speakers';
import SpeakerSection from './speakers-page/components/SpeakerSection';
import AllSpeakers from './speakers-page/components/AllSpeakers';
import Participants from './participants-page/Participants';
import ParticipantsPanel from './participants-page/blocks/ParticipantsPanel';
import SpeakerPage from './speakers-page/Speaker';
import SuccessRegistration from './blocks/success/SuccessRegistration';
import ErrorRegistration from './blocks/errors/ErrorRegistration';
import RestorePasswordPage from './restore-password-page/Restore';
import Schedule from './schedule-page/Schedule';
import ScheduleSection from './schedule-page/blocks/ScheduleSection';
import ScheduleRoomPage from './schedule-page/ScheduleRoom';
import Error from './blocks/errors/Error404';
import './styles/reset.css';
import './styles/fonts.css';


const store = newStore();

render(
  <Provider store={store}>
    <Router history={browserHistory} >
      <Route path='/' component={Layout} >
        <IndexRoute component={Landing} />
        <Route path='/register' component={Register} />
        <Route path='/reviews' component={Reviews} />
        {/*<Route path='/about' component={About} />*/}
        <Route path='/profile' component={UserProfile} />
        <Route path='/auth' component={Authorization} />
        <Route path='/speakers' component={Speakers} >
          <IndexRoute component={AllSpeakers}/>
          <Route path='(:filter)' component={SpeakerSection}/>
        </Route>
        <Route path='/participants' component={Participants} >
          <IndexRoute component={ParticipantsPanel}/>
          <Route path='(:filter)' component={ParticipantsPanel}/>
        </Route>
        <Route path='/schedule' component={Schedule} >
          <Route path='(:filter)' component={ScheduleSection}/>
        </Route>
        <Route path='/room-event/(:filter)' component={ScheduleRoomPage} />
        <Route path='/speaker(:filter)' component={SpeakerPage} />
        <Route path='/success-registration' component={SuccessRegistration} />
        <Route path='/fail-registration' component={ErrorRegistration} />
        <Route path='/restore-password' component={RestorePasswordPage} />
      </Route>
      {/*Not Found handler*/}
      <Route path='*' component={Error}/>
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js